import React, { useState, useEffect, useRef } from 'react';
import { Button, ItemCard } from '../../components';
import { getItems } from '../../services/items';
import { CoverWrapper, ItemsWrapper, H1, ButtonWrapper } from './Home.styles';
import logo from './website_cover.png';
import { useHistory } from 'react-router-dom';
import { getSetting } from '../../services/settings';

export const Home = () => {
  const [items, setItems] = useState([]);
  const [shopItemLimit, setShopItemLimit] = useState(0);

  let history = useHistory();
  const mountedRef = useRef(true);

  useEffect(() => {
    const fetchItems = async () => {
      const items = await getItems(1, 8, 'approved', 'in-shop');
      if (!mountedRef.current) return null;
      if (items) setItems(items);
    };

    const fetchSetting = async () => {
      let settingValue = 0;
      try {
        settingValue = await getSetting('shopItemLimit');
      } catch (error) {
        console.error(`Error in Home.fetchSetting: ${error}`);
      }
      if (!mountedRef.current) return null;
      const numericSettingValue = Number(settingValue);
      setShopItemLimit(
        Number.isFinite(numericSettingValue) ? numericSettingValue : 0
      );
    };

    fetchItems();
    fetchSetting();

    return () => {
      mountedRef.current = false;
    };
  }, []);

  return (
    <div>
      <CoverWrapper to="/">
        <h1>Give Your Best Shop</h1>
        <p>Browse our catalogue of gifted items and</p>
        <p>shop up to {shopItemLimit} items per week for free!</p>
        <img alt="give-your-best-cover" src={logo} />
      </CoverWrapper>
      <H1>All Items</H1>
      <ItemsWrapper my={1} mx={-1} display="flex" flexWrap="wrap">
        {items.length
          ? items.map((item) => {
              if (item.photos.length) {
                return <ItemCard key={item._id} item={item} />;
              } else {
                return '';
              }
            })
          : ''}
      </ItemsWrapper>
      <ButtonWrapper>
        <Button center primary onClick={() => history.push(`/products/`)}>
          {'Browse All >'}
        </Button>
      </ButtonWrapper>
    </div>
  );
};
